
define('jst!conversations/chat/_people_list_empty',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if (query) { %>\n  <li class="empty"><%= translations.no_search_results %></li>\n<% } %>\n\n<li class="empty"><%- translations.send_message %></li>\n');
 });

